import * as zod from 'zod';

export const WeldPositionerCommand = zod.object({
  kind: zod.literal('WeldPositionerCommand'),
  /**
   * Which positioner to drive. Botman's command routing falls back to matching
   * on `kind` alone when no device is named, which in a cell with two
   * positioners would turn both; naming the device keeps that case correct.
   */
  deviceID: zod.string(),
  subCommand: zod.discriminatedUnion('kind', [
    zod.object({ kind: zod.literal('rotate') }),
    zod.object({ kind: zod.literal('stop') }),
  ]),
});

export type WeldPositionerCommand = zod.infer<typeof WeldPositionerCommand>;
